package br.com.texeratx.boardgametimeapp.core.active_match

enum class ActiveMatchStatus {
    RUNNING,
    PAUSED,
    FINISHED
}
